"use strict";

var _getOwnPropertySymbols = require("babel-runtime/core-js/object/get-own-property-symbols");

var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _create = require("babel-runtime/core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _setPrototypeOf = require("babel-runtime/core-js/object/set-prototype-of");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = _setPrototypeOf2.default || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? (0, _create2.default)(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || _assign2.default || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof _getOwnPropertySymbols2.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols2.default)(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CascaderMenuItem = /** @class */function (_super) {
    __extends(CascaderMenuItem, _super);
    function CascaderMenuItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // shouldComponentUpdate(nextProps: CascaderMenuItemProps, nextState: { }) {
    //     return this.props.className != nextProps.className;
    // }
    CascaderMenuItem.prototype.render = function () {
        var _a = this.props,
            className = _a.className,
            rest = __rest(_a, ["className"]);
        return React.createElement("div", __assign({ className: this.props.className }, rest));
    };
    return CascaderMenuItem;
}(React.Component);
var CascaderMenu = /** @class */function (_super) {
    __extends(CascaderMenu, _super);
    function CascaderMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CascaderMenu.prototype.render = function () {
        var _a = this.props,
            className = _a.className,
            rest = __rest(_a, ["className"]);
        return React.createElement("div", __assign({ className: "cn-addr-caslist" }, rest));
    };
    CascaderMenu.Item = CascaderMenuItem;
    return CascaderMenu;
}(React.Component);
exports.default = CascaderMenu;
//# sourceMappingURL=CascaderMenu.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-address@0.0.80@@alicd/crui-address/lib/CascaderMenu.js
// module id = 250
// module chunks = 0